import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoverageInfoComponent } from './coverage-info.component';
import { RouterModule, Routes } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreInputsModule } from '@tmhcc-ng-lib/framwork/core-inputs';
import { PageStepNavModule } from '../shared/page-step-nav/page-step-nav.module';
import { PageHeaderNavigationComponent } from '../shared/page-step-nav/page-header-navigation/page-header-navigation';

const routes: Routes = [
  {
    path: '',
    component: CoverageInfoComponent
    //canDeactivate: [UnsavedDataGaurd]
  }
];

@NgModule({
  declarations: [CoverageInfoComponent],
  imports: [
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    CoreInputsModule,
    CommonModule,
    PageStepNavModule
  ],
  exports: [RouterModule]
})
export class CoverageInfoModule {}
